import React from 'react';
import './accent-stripe.styl';

export default function AccentStripe() {
  return <div className="lbp-accent-stripe" />;
}